export const Projectdata=[
    {
        id:"0",
        title: "Mail Chimp",
        about: "Mailchimp is an American marketing automation platform and email marketing service for managing mailing lists and creating email marketing campaigns to send to customers.",
        tags:["React", "Redux","Java Script","Firebase","Chakra UI","Fav Icon","HTML","SCSS","Paypal Gateway"],
        demo:"https://clone-mailchimpclone.netlify.app/",
        github:"https://github.com/adityapathak-auto/mailchimp-clone",
        image:require("../body/assets/projects/MAILCHIMP HOME.png")

    },
    {
        id:"1",
        title:"Freshly",
        about:"A web application for meal delivery across the U.S on a weekly basis.A vast menu according to the needs and taste of consumers.",
        tags:["HTML","CSS","Java Script","Local Storage"],
        demo:"https://freshly-clone-aditya.netlify.app/",
        github:"https://github.com/adityapathak-auto/Freshly",
        image: require("../body/assets/projects/Freshly.png")
    },
    {
        id:"2",
        title:"uPGrad",
        about:"A web Ed-Tech application offering online courses to its learnersglobally.Profession based course selection.",
        tags:["HTML","CSS","Java Script","Local Storage","Node JS","Mongo DB","Express","Mongoose"],
        demo:"https://clone-upgrad.herokuapp.com/",
        github:"https://github.com/adityapathak-auto/upGrad.com-clone",
        image: require("../body/assets/projects/UPGRAD HOME .png")

    }
]